var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsNewsReportOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.4,25.6V13.5H16v65.1c0,3.8,3.1,6.9,6.9,6.9h58.1c3.8,0,6.9-3.1,6.9-6.9V25.6H78.4z M83.7,29.9v48.6 c0,1.5-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6V29.9H83.7z M20.3,17.8h53.9v60.8c0,0.9,0.2,1.8,0.5,2.6H22.9c-1.5,0-2.6-1.2-2.6-2.6V17.8 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 28.5,
    width: 45.1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 38.3,
    width: 20.6,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 48.1,
    width: 20.6,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 57.9,
    width: 20.6,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 67.7,
    width: 20.6,
    height: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.2,38.2v34.1H70V38.2H51.2z M66.5,69.2H54.7V41.2h11.9V69.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsNewsReportOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_NewsReport_Outline_Black_RGB.4fc4a850103480fdedfb464e2d43793f.svg";
export { ForwardRef as ReactComponent };